import React, {FormEvent} from 'react';
import styled from 'styled-components';
import ExpandingTextInput from "../ExpandingTextInput";
import CheckboxInput from "../SingleFieldForm/CheckboxInput";
import {IUEvent} from "../../lib/event";
import {TAppElkEventQuestion} from "TProtocol/prototypes/events/messages";
import {useEditEventContext} from "../../contexts/EditEventContext";

interface Props {
    event: IUEvent;
    question: TAppElkEventQuestion
}

const EditableQuestion = ({ event, question }: Props) => {
    const editEventContext = useEditEventContext();

    const handleQuestionTextChange = (value: string) => {
        question.question = value
        editEventContext.modifyQuestion(question)
    }

    const handleQuestionCheckboxChange = (e: FormEvent<HTMLInputElement>) => {
        question.isRequired =  e.currentTarget.checked;
        editEventContext.modifyQuestion(question)
    };

    return <Container>
        <ExpandingTextInput
            label="Question?"
            value={question.question}
            charLimit={1000}
            onChange={(value) => handleQuestionTextChange(value)}
            textColor="var(--shine-text-color)"
        />
    </Container>
};

const Container = styled.div`
  font-size: 24px;
  display: flex;
  flex-direction: column;
  max-width: 100vw;
`;

export default EditableQuestion;
